const en_trans_itemin = {
    "": "item in",
    add: "create item in",

    label: {
        sn_upload_text: "Download Excel template for Serial Number upload",
    },

    error: {
        create: "Failed to create item in",
        edit: "Failed to update item in",
    },

    success: {
        create: "Item in created successfully",
        edit: "Item in updated successfully",
    },
}

export default en_trans_itemin;